import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  credential: '',
  resourceGroup: 'data',
  operation: 'getRows',
  tableId: '',
  dataFlowId: '',
  scheduleId: '',
  viewId: '',
  maxRows: 0,
  filterBody: '',
  data: '',
  csvData: '',
  updateData: '',
  filter: '',
  multipleRows: 'first',
  refreshMode: 'reload',
  errorHandling: 'stop',
  includeSchema: false,
};

export default defaults;
